export default {
    similarProducts: [
        // {
        //     "actualProductId": 982,
        //     "productName": "Jord",
        //     "description": "<p>Jord mellan tårna?</p>",
        //     "imageSrc": "https://i0.wp.com/turnr515038026.wpcomstaging.com/wp-content/uploads/2023/08/jord.jpeg?fit=400%2C300&ssl=1",
        //     "purchasePrice": 1099,
        //     "currency": "DEFAULT",
        //     "properties": [],
        //     "variants": [
        //         {
        //             "id": 4229,
        //             "productName": "Jord",
        //             "imageSrc": "https://i0.wp.com/turnr515038026.wpcomstaging.com/wp-content/uploads/2023/08/jord.jpeg?fit=400%2C300&ssl=1",
        //             "hasInventory": false,
        //             "properties": [],
        //             "productVariantTypeValues": []
        //         }
        //     ]
        // }
    ],
};
